<template>
  <OttWidget>
    <component :is="widgetComponent"
               :menuLinks="menuLinks"
               :search-target="searchTarget"
               :search-field-name="searchFieldName"
               :skip-to-content="skipToContent"
               :menuTitleLg="lgMenuLabel"
               :languageUrl="languageUrl"
               :homeUrl="homeUrl"
               :homeTitle="homeTitle"
               :searchControls="searchControls"
               :gatewayLinks="gatewayLinks"
               :apiServer="apiServer"></component>
  </OttWidget>
</template>

<script>

import OttWidget from './OttWidget.vue';
import {Components} from 'ottuxlib';
import axios from 'axios'
const OttawaHeader = Components.OttawaHeader;

export default {
  name: 'OttHeaderWidget',
  components: {
    OttWidget,
    OttawaHeader
  },
  props: {
    apiPath: String
  },
  data: function() {
    return {
      widgetComponent : 'OttawaHeader',
      menuLinks: this.$t('header.menuLinks'),
      gatewayLinks:[],
      searchTarget: 'https://ottawa.ca/search',
      searchFieldName: 'searchfield',
      skipToContent: 'main-content',
      languageUrl: '/' + this.$i18n.oppositeLanguage(),
      lgMenuLabel: this.$t('header.signInButton'),
      homeUrl: 'https://ottawa.ca',
      homeTitle: 'Home',
      searchControls: '',
      apiServer: 'https://ottawa.ca',
    }
  },
  methods: {
    parseResponse: function(response) {
      if (typeof response !== 'undefined' && response !== null
        && typeof response.data !== 'undefined' && response.data !== null) {
        this.gatewayLinks = response.data;
      }
    }
  },
  // Parse the properties. If gateways are provided, use them. If not make a REST call to get the gateways.
  created: async function() {
    // Check for locally provided Gateways.
    if (typeof this.$root.links !== 'undefined' && this.$root.links !== null) {
      try {
        this.gatewayLinks = JSON.parse(this.$root.links);
      } catch(error) {
        console.error(error.message);
      }
    }  else {
      try {
        //await this.makeWebServiceCall(this.apiPath);
        let url = process.env.VUE_APP_OTTAWA_CA_URL + this.$i18n.currentLanguage() + '/api/gateway/index'
        console.log('fetchGetwayLinks', 'Fetching ' + url)
        let response = await axios.get(url)
        if (response.status === 200 && response.data) {
          this.gatewayLinks = response.data
        }
      } catch(error) {
        console.error(error.message);
      }
    }
  },
  mounted: function() {
  // Set the skip to main content element id.
    if (typeof this.$root.skipToContentId !== 'undefined' && this.$root.skipToContentId !== null) {
      this.skipToContent = this.$root.skipToContentId;
    }
    // Validate the skip to main content element id.
    if (document && !document.getElementById(this.skipToContent)) {
      console.warn('Could not find the skip to content id.');
    }
    // Set the extra menu links
    if (typeof this.$root.extraLinks !== 'undefined' && this.$root.extraLinks !== null) {
      try {
        this.menuLinks = JSON.parse(this.$root.extraLinks);
      } catch(error) {
        console.error(error.message);
      }
    }
    // Set the search target
    if (typeof this.$root.searchAction !== 'undefined' && this.$root.searchAction !== null) {
      this.searchTarget = this.$root.searchAction;
    }
    // Set the search field name
    if (typeof this.$root.searchNameAttr !== 'undefined' && this.$root.searchNameAttr !== null) {
      this.searchFieldName = this.$root.searchNameAttr;
    }
    // Set the language link URL.
    if (typeof this.$root.languageLink !== 'undefined' && this.$root.languageLink !== null) {
      this.languageUrl = this.$root.languageLink;
    }
    // Set the menu label.
    if (typeof this.$root.menuLabel !== 'undefined' && this.$root.menuLabel !== null) {
      this.lgMenuLabel = this.$root.menuLabel;
    }
    // Set the home url.
    if (typeof this.$root.homeLinkUrl !== 'undefined' && this.$root.homeLinkUrl !== null) {
      this.homeUrl = this.$root.homeLinkUrl;
    }
    // Set the home title.
    if (typeof this.$root.homeLinkTitle !== 'undefined' && this.$root.homeLinkTitle !== null) {
      this.homeTitle = this.$root.homeLinkTitle;
    }
    // Set the search controls attribute.
    if (typeof this.$root.searchResultsId !== 'undefined' && this.$root.searchResultsId !== null) {
      this.searchControls = this.$root.searchResultsId;
    }
  }
}
</script>
